module.exports = __webpack_public_path__ + "static/media/Camarones a la parrilla.ec81d59a.jpg";